"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fallBackEnvs = void 0;
/**
 * RSE (2024 02) Where React Native cannot be passed environment to the process
 *
 * This is either temporary, or may be `regex`'d at some point by a predeploy script
 */
exports.fallBackEnvs = {
    AWS_DEFAULT_REGION: 'ap-southeast-2',
    accountId: 'xxxxxxxxxxxxx',
    projectCode: 'iotv',
    projectName: 'iotv',
    stage: 'dev',
    AWS_PROFILE: 'iotv-test',
};
